import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import * as moment from 'moment-timezone';

import { APP_SETTINGS } from '../../shared/models/backofficeConfiguration';
import { UserSite } from '../../shared/models/UserSite';
import { ExecuteService } from '../../shared/services/executeService.service';
import { ErrorHandlerService } from '../../shared/services/errorHandler.service';
import { CustomEncoder } from '../../shared/services/url.service'
import { UserSiteRequest } from '../../shared/models/UserSiteRequest';



@Injectable()
export class UsersSiteService {
  private usersApiURL = APP_SETTINGS.UsersApiUrl;
  private userFunctionsApiURL = APP_SETTINGS.UserFunctionsApiUrl;
  private userFunctionsApiKey = APP_SETTINGS.UserFunctionsApiKey;

  constructor(
    private executeService: ExecuteService,
    private errorHandler: ErrorHandlerService) {
  }

  public GetById(userId: string): Observable<UserSite> {
    let url: string = `${this.usersApiURL}${userId}`;

    return this.executeService.ExecuteWithToken('get', url).
      pipe(
      map(response => this.mapResponseModel(response)),
        catchError(this.errorHandler.handleError('UsersSiteService_GetById userId', null))
      );
  }

  public GetByEmail(email: string): Observable<UserSite> {
    let url: string = this.usersApiURL;
    let params = new HttpParams({ encoder: new CustomEncoder() }).set('email', email);

    return this.executeService.ExecuteWithToken('get', url, params).
      pipe(
      map(response => this.mapResponseModel(response)),
        catchError(this.errorHandler.handleError('UsersSiteService_GetByEmail email', null))
      );
  }

  public FindByEmail(email: string): Observable<UserSite[]> {
    let url: string = `${this.usersApiURL}UserFindByEmail`;    
    let params = new HttpParams({ encoder: new CustomEncoder() }).set('email', email);

    return this.executeService.ExecuteWithToken('get', url, params).
      pipe(
        map(response => this.mapResponseModelList(response)),
        catchError(this.errorHandler.handleError('UsersSiteService_FindByEmail email', []))
      );
  }

  public Edit(id: string, user: UserSite): Observable<any> {
    let url: string = `${this.usersApiURL}${id}`;
    var body = this.mapRequestModel(user);

    return this.executeService.ExecuteWithToken('put', url, null, body).
      pipe(
        catchError(this.errorHandler.handleError('UserSiteService_Edit', null))
      );
  }

  public DeleteUser(email: string): Observable<any> {
    const url = this.usersApiURL;
    const params = new HttpParams({ encoder: new CustomEncoder() }).set('email', email);
    
    return this.executeService.ExecuteWithToken('delete', url, params, null).
      pipe(
        catchError(this.errorHandler.handleAndThrowError('UsersSiteService_Delete', null, true))
      );
  }

  public DeleteFromMailchimp(email: string): Observable<any> {
    const url = this.userFunctionsApiURL + '/api/DeleteUserFromMailchimp';
    const params = new HttpParams({ encoder: new CustomEncoder() })
    .set('email', email)
    .set('code', this.userFunctionsApiKey);

    return this.executeService.Execute('post', url, params).
      pipe(
        catchError(this.errorHandler.handleAndThrowError('UsersSiteService_DeleteFromMailchimp', null, true))
      );
  }

  private mapRequestModel(user: any): UserSiteRequest {
    let response: UserSiteRequest;
    if (user != null) {
      response = {
        name: user.Name,
        surname: user.Surname,
        phone: user.Phone,
        premiumExpirationDateUtc: user.PremiumExpirationDateUtc.toISOString()
      }
    }
    return response;
  }

  private mapResponseModel(user: any): UserSite {
    let response: UserSite;
    if (user != null) {
      response = {
        UserId: user.id,
        Name: user.name,
        Surname: user.surname,
        Email: user.email,
        IsPremium: user.isPremium,
        Phone: user.phone,
        UserName: user.userName,
        PremiumExpirationDateUtc: moment(user.premiumExpirationDateUtc),
        IsEmailConfirmed: user.emailConfirmed,
      };
    }

    return response;
  }

  private mapResponseModelList(users: any[]): UserSite[] {
    let response: UserSite[] = [];
    if (users != null) {
      response = users.map(u => this.mapResponseModel(u));
    }

    return response;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/usersSite.service.ts